import { palette } from '@livable/saas-react-components';
const MuiCheckbox = {
  styleOverrides: {
    root: {
      color: palette.shades[600],
      marginRight: '0',
      padding: '6px',
      width: '36px',
      height: '36px',
      transition: "color ".concat(palette.transitions.short),
      '&.Mui-checked': {
        transition: 'none',
        color: palette.primary.main,
        '&:hover': {
          color: palette.primary.main
        }
      },
      '&.Mui-disabled': {
        '& path': {
          fill: palette.shades[300]
        }
      },
      '&:hover': {
        color: palette.shades[800]
      }
    }
  },
  variants: [{
    props: {
      variant: 'small'
    },
    style: {
      padding: '0',
      width: 'initial',
      height: 'initial'
    }
  }]
};
export default MuiCheckbox;